import { Injectable } from "@angular/core";

export const Roles: any = {
  lol: [
    'top',
    'jungle',
    'mid',
    'bottom',
    'support',
    'fill'
  ],
  'lol-classic': [
    'top',
    'jungle',
    'mid',
    'bottom',
    'support',
    'fill'
  ],
  'wild-rift': [
    'solo',
    'jungle',
    'mid',
    'duo',
    'support',
    'fill'
  ],
  valorant: [
    'duelist',
    'controller',
    'initiator',
    'sentinel',
    'fill'
  ],
  apex: [
    'assault',
    'skirmisher',
    'recon',
    'support',
    'controller',
    'fill'
  ],
  marvel: [
    'duelist',
    'strategist',
    'vanguard',
    'fill'
  ]
};

@Injectable()
export class RolesService { }